module.exports = __webpack_public_path__ + "assets/img/EISS-Super-eBook-w720.7982c9c3.webp";